import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
} from "recharts";

const COLORS = ["#32bef0", "#29306a", "#a5b4fc"];

interface Props {
  receitaPorFranqueado: { name: string; value: number }[];
  statusPagamentos: { name: string; value: number }[];
}

const GraficosFinanceiros: React.FC<Props> = ({
  receitaPorFranqueado,
  statusPagamentos,
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      {/* Receita por Franqueado */}
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-semibold text-[#29306a] mb-4">
          Receita - Top 5
        </h3>

        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={receitaPorFranqueado}>
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Bar dataKey="value" fill="#32bef0" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      {/* Status dos Pagamentos */}
      <div className="bg-white p-6 rounded-lg shadow">
        <h3 className="text-lg font-semibold text-[#29306a] mb-4">
          Status dos Pagamentos
        </h3>

        <ResponsiveContainer width="100%" height={300}>
          <PieChart>
            <Pie
              data={statusPagamentos}
              dataKey="value"
              nameKey="name"
              outerRadius={100}
              label
            >
              {statusPagamentos.map((_, index) => (
                <Cell
                  key={index}
                  fill={COLORS[index % COLORS.length]}
                />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default GraficosFinanceiros;
